import {
  CreateSetupIntentForCardVerificationResponse,
  GetAddPaymentInfoResponse,
  GetPaginatedPaymentsResponse,
  GetPaymentClientSecretRequest,
  GetPaymentPaginatedRequest,
  GetPendingPaymentsResponse,
  Payment,
  RetryPaymentResponse,
  VerifyStripePaymentRequest
} from '@/types/payment';
import fetchData, { Methods } from '@/utils/api';
import {
  APIENDPOINT_PAYMENT_INFO,
  APIENDPOINT_CLIENT_SECRET,
  APIENDPOINT_MONTH,
  APIENDPOINT_PAGINATED,
  APIENDPOINT_PAYMENT_INTENT,
  APIENDPOINT_PAYMENT_PAYMENT_ID,
  APIENDPOINT_PAYMENTS,
  APIENDPOINT_PENDING_PAYMENTS,
  APIENDPOINT_PROOF_OF_PAYMENT,
  APIENDPOINT_RETRY_PAYMENT,
  APIENDPOINT_SETUP_INTENT_SECRET,
  APIENDPOINT_VERIFY_PAYMENT,
  APIENDPOINT_YEAR
} from '@/constants/api_endpoints';

export async function getPendingPayments(): Promise<GetPendingPaymentsResponse> {
  return fetchData(Methods.GET, `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PENDING_PAYMENTS}`);
}

export async function getPaginatedPaymentsByDate(
  year: number,
  month: number,
  page: number,
  limit: number,
  populate: boolean,
  search?: string,
  filters?: Object
): Promise<GetPaginatedPaymentsResponse> {
  return fetchData(
    Methods.GET,
    `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PAGINATED}${APIENDPOINT_MONTH}/${month}${APIENDPOINT_YEAR}/${year}`,
    {
      page,
      limit,
      populate,
      filters: JSON.stringify(filters),
      search
    }
  );
}

export async function createSetupIntentForCardVerification(): Promise<CreateSetupIntentForCardVerificationResponse> {
  return fetchData(Methods.POST, `${APIENDPOINT_PAYMENTS}${APIENDPOINT_SETUP_INTENT_SECRET}`);
}

export async function getClientSecretByPaymentIntent(
  paymentId: string
): Promise<CreateSetupIntentForCardVerificationResponse> {
  return fetchData(
    Methods.GET,
    `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PAYMENT_INTENT}/${paymentId}${APIENDPOINT_CLIENT_SECRET}`
  );
}

export async function uploadProofOfPayment(
  paymentId: string,
  documentId: string
): Promise<Payment[]> {
  return fetchData(Methods.POST, `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PROOF_OF_PAYMENT}`, {
    payment_id: paymentId,
    document_id: documentId
  });
}

export async function retryPayment(paymentId: string): Promise<RetryPaymentResponse> {
  return fetchData(
    Methods.POST,
    `${APIENDPOINT_PAYMENTS}/${paymentId}${APIENDPOINT_RETRY_PAYMENT}`
  );
}

export async function getPaymentsPaginated({
  page,
  limit,
  populate,
  search,
  filters
}: GetPaymentPaginatedRequest): Promise<GetPaginatedPaymentsResponse> {
  return fetchData(Methods.GET, `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PAGINATED}`, {
    page,
    limit,
    populate,
    filters: JSON.stringify(filters),
    search
  });
}

export async function getPaymentClientSecret({
  paymentId,
  existingCustomer = true
}: GetPaymentClientSecretRequest): Promise<RetryPaymentResponse> {
  return fetchData(
    Methods.GET,
    `${APIENDPOINT_PAYMENTS}${APIENDPOINT_CLIENT_SECRET}/${paymentId}/${existingCustomer}`
  );
}

export async function verifyStripePayment({ paymentId, paymentIntentId }: VerifyStripePaymentRequest) {
  return fetchData(Methods.POST, `${APIENDPOINT_PAYMENTS}${APIENDPOINT_VERIFY_PAYMENT}/${paymentIntentId}${APIENDPOINT_PAYMENT_PAYMENT_ID}/${paymentId}`);
}

export async function getAddPaymentInfo(
  paymentId: string
): Promise<GetAddPaymentInfoResponse> {
  return fetchData(
    Methods.GET,
    `${APIENDPOINT_PAYMENTS}${APIENDPOINT_PAYMENT_INFO}/${paymentId}`
  );
}